import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'roma-modal-enable-module',
  templateUrl: './modal-enable-module.component.html',
  styleUrls: ['./modal-enable-module.component.scss'],
})
export class ModalEnableModuleComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<ModalEnableModuleComponent>) {}

  ngOnInit() {}

  onClose(): void {
    this.dialogRef.close('closed');
  }

  onActivate(): void {
    this.dialogRef.close('activated');
  }
}
